import classNames from 'classnames'
import React from 'react'
import { ValueLocked } from 'src/components/framework/icons/value-locked'
import { RatioGraph } from 'src/components/page/ratios/ratio-graph'
import { MarketRatioRow, RatioLink } from 'src/components/page/ratios/ratios'

export interface Props {
  label: {
    text: string
    visible: boolean
  }
  rows: ReadonlyArray<MarketRatioRow<any>>
}

export const MarketRatioTable: React.FC<Props> = ({ label, rows }) => {
  return (
    <table className={classNames('stk-table-stretched', 'stk-space-out-t-0')}>
      <thead>
        <tr>
          <th colSpan={2}>
            {label.visible ? (
              label.text
            ) : (
              <span className="visually-hidden">{label.text}</span>
            )}
          </th>
          <th style={{ width: '1%' }}>Industry</th>
          <th style={{ width: '1%' }}>Market</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            <td>
              <RatioLink id={row.ratioId}>{row.label}</RatioLink>
            </td>
            <td
              className={'stk-text-align-r'}
              style={{ width: '1%', whiteSpace: 'nowrap' }}
            >
              {row.enabled && row.data ? (
                <>
                  {row.data.value === null
                    ? 'n/a'
                    : row.data.value + (row.unit || '')}
                </>
              ) : (
                <ValueLocked />
              )}
            </td>
            <td>
              <RatioGraph
                percentile={row.data?.industry || 0}
                locked={!row.enabled}
              />
            </td>
            <td>
              <RatioGraph
                percentile={row.data?.industry || 0}
                locked={!row.enabled}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
